import React from 'react';
import PlayListArtistDetailContainer from 'containers/PlayListArtistDetailContainer';

export default function PlayListArtistDetailPage() {
  return <PlayListArtistDetailContainer />;
}
